import { defineStore } from 'pinia';
import { ref } from 'vue';
import { settingService } from '../services';

export const useSettingStore = defineStore('setting', () => {
    const serverVersion = ref<string | null>(null)

    async function getVersion() {
        serverVersion.value = null
        const dataVersion = await settingService.getVersion()
        serverVersion.value = dataVersion
    }

    return {
        serverVersion,
        getVersion
    }
})